var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import getTranslation from "../../../../strings/getTranslations";
import { INCOME_CAPTURE_VIEWS, useIncomeCaptureContext, } from "../../../../context/incomeCaptureContext";
import { CloseButton, FooterButton, FooterWrapper, IncomeUpdateButton, } from "./subcomponents";
var IncomeCaptureSubmitButton = function () {
    var t = getTranslation().t;
    return (_jsx(IncomeUpdateButton, __assign({ type: "submit", 
        // @ts-expect-error component library should spread this but doesn't expect the button attribute "form" which is in semantic HTML.
        form: "income-capture-form", buttonType: "primary" }, { children: t("incomeCapture.modal.footer.saveButton") })));
};
export var IncomeCaptureModalFooter = function () {
    var _a = useIncomeCaptureContext(), view = _a.state.view, handleClose = _a.handleClose;
    var t = getTranslation().t;
    return (_jsx(FooterWrapper, { children: view === INCOME_CAPTURE_VIEWS.UPDATE_INCOME ? (_jsxs(_Fragment, { children: [_jsx(FooterButton, __assign({ buttonType: "text", onClick: function () { return handleClose(); } }, { children: t("incomeCapture.modal.footer.skipButton") })), _jsx(IncomeCaptureSubmitButton, {})] })) : (_jsx(CloseButton, __assign({ buttonType: "primary", onClick: function () { return handleClose(); } }, { children: t("actions.close") }))) }));
};
